import { browserTracingIntegration, init } from '@sentry/browser';
import { sentryOptions } from './sentry-options.mjs';

const settings = document.querySelector('meta[name="sentry-browser-config"]');

if (settings) {
    // app.js imports this module first: a failure here must not stop the page's own scripts.
    try {
        init(sentryOptions(JSON.parse(settings.content), browserTracingIntegration()));
    } catch (error) {
        console.error('Error monitoring did not start', error);
    }
}
